import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { PensionContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionContributionInstruction";
import { BankAccountsClient } from "../../../../../../Wrap/Api/BankAccounts/BankAccounts";
import { DrawdownIncomeAmendmentInstructionCalculationsClient } from "../../../../../../Wrap/Api/Drawdown/DrawdownIncomeAmendmentInstructionCalculations";
import { ProcessType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { BankAccount } from "../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";
import { GadReviewInstructionDispatcher } from "../Store/Variable";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { CappedPensionArrangementsFlexiConversionAvailabilitiesClient } from "../../../../../../Wrap/Api/Drawdown/CappedPensionArrangementsFlexiConversionAvailabilities";
import {
    CappedPensionArrangementsFlexiConversionAvailability
} from "../../../../../../Wrap/Models/Domains/Drawdown/CappedPensionArrangementsFlexiConversionAvailability";
import {
    DrawdownIncomeAmendmentCalculations
} from "../../../../../../Wrap/Models/Domains/Drawdown/DrawdownIncomeAmendmentCalculations";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";

export class GadReviewAction {

    public static getInstruction(
        id,
        hierarchyId,
        subAccountHierarchyId,
        customerId,
        arrangementId
    ): void {
        const pensionContributionInstruction = new PensionContributionInstructionClient();
        if (CommonHelper.isNullOrEmpty(id)) {
            pensionContributionInstruction
                .post(subAccountHierarchyId, hierarchyId, ProcessType.GADReview)
                .onSuccess((result) => {
                    const instructionId = result.Result;
                    const model = pensionContributionInstruction.get(instructionId, customerId, "GADReview",
                    );
                    model.onSuccess((result) => {
                        this.populateArrangementId(result, customerId, arrangementId);
                    });
                });
        } else {
            pensionContributionInstruction.get(id, customerId, "GADReview",
                ).onSuccess((result) => {
                GadReviewInstructionDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: result,
                });
            });
        }
    }

    public static populateArrangementId(model : PensionContributionModel, customerId : number, arrangementId : number){
        const pensionContributionInstruction = new PensionContributionInstructionClient();
        model.Contribution.DrawdownIncomeAmendmentModel.DrawdownIncomeAmendmentInstruction.PensionArrangementId = arrangementId;
        var promise = pensionContributionInstruction.put(model, customerId, ProcessType.GADReview);
        promise.onSuccess((result) => {
            GadReviewInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });
    }


    public static getDrawdownIncomeCalculations(instructionId: number, callback?: (result: DrawdownIncomeAmendmentCalculations) => void) {
        const client = new DrawdownIncomeAmendmentInstructionCalculationsClient();
        const promise = client.get(instructionId);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });
    }

    public static getCappedPensionArrangementFlexiConversionAvailabilities(subAccountHierarchyId: string, callback?: (result: CappedPensionArrangementsFlexiConversionAvailability[]) => void): void {
        const availabilitiesClient  = new CappedPensionArrangementsFlexiConversionAvailabilitiesClient();
        const promise = availabilitiesClient.get(
            subAccountHierarchyId
        );
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });
        promise.onError((error) => {
            callback(error);
        });
    }

    public static saveInstruction(from, data: any, customerId?: number, callback?: (data) => void): void {
        const pensionContributionInstruction = new PensionContributionInstructionClient();
        let promise = pensionContributionInstruction.put(data, customerId, ProcessType.GADReview);
        promise.onSuccess((result) => {
            GadReviewInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (result.Errors != null && result.Errors.length > 0) {
                callback(result.Errors.map((ele) => ele.UserMessage));
            } else {
                callback(result);
            }
        });

        promise.onError((err) => {
            GadReviewInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static submitInstruction(id, data, customerId, claccountId, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.put(id, data, customerId, claccountId);
        promise.onSuccess((result) => {
            GadReviewInstructionDispatcher.dispatch({ actionType: ActionType.Success, payload: result });
            if (callback) {
                callback();
            }
        });

        promise.onError((err) => {});
        Promise.resolve(callback());
    }

    public static deleteInstruction(id, callback?: VoidFunction): void {
        Promise.resolve(callback());
    }
}
